import {CheckCircle, HighlightOff, Pending} from "@mui/icons-material";
import React, {useEffect, useState, useContext} from "react";
import {BrandContext} from "../../common/BrandContext";
import Tab from "../../common/Tab";
import Tabs from "../../common/Tabs";
import TrailCompletedContent from "./studentTrailTabsContent/TrailCompletedContent";
import TrailOpenContent from "./studentTrailTabsContent/TrailOpenContent";
import TrailClosedContent from "./studentTrailTabsContent/TrailClosedContent";

const TABS = {
    IN_PROGRESS: {id:'open', name: 'In progress', val: 0, hash: 'in-progress'},
    COMPLETED: {id:'completed', name:'Completed', val: 1, hash: 'completed'},
    INCOMPLETE_CLOSED: {id:'closed', name:'Incomplete / Closed', val: 2, hash: 'incomplete-closed'}
}
const StudentTrailTabs = (props) => {

    return (
        <div id="pathways" style={{clear: 'both'}} className="gen-sub-cont">
            <Tabs id={'studentTrailTabs'} variant="standard" destroyOnHidden={true}>
                <Tab id={'studentTrailsInProgress'} hash={TABS.IN_PROGRESS.hash}
                    children={<TrailOpenContent/>}
                    tab={
                        <>
                            <Pending className={'margin-r--m'}/>
                            <span className={'margin-r--m tabText'}>{TABS.IN_PROGRESS.name}</span>
                        </>
                    }
                    key={TABS.IN_PROGRESS.val} value={TABS.IN_PROGRESS.val}/>
                <Tab id={'studentTrailsCompleted'} hash={TABS.COMPLETED.hash}
                    children={<TrailCompletedContent/>}
                    tab={
                        <>
                            <CheckCircle className={'margin-r--m'}/>
                            <span className={'margin-r--m tabText'}>{TABS.COMPLETED.name} </span>
                        </>
                    }
                    key={TABS.COMPLETED.val} value={TABS.COMPLETED.val}/>
                <Tab id={'studentTrailsInCompleteClosed'} hash={TABS.INCOMPLETE_CLOSED.hash}
                    children={<TrailClosedContent/>}
                    tab={
                        <>
                            <HighlightOff className={'margin-r--m'}/>
                            <span className={'margin-r--m tabText'}>{TABS.INCOMPLETE_CLOSED.name}</span>
                        </>
                    }
                    key={TABS.INCOMPLETE_CLOSED.val} value={TABS.INCOMPLETE_CLOSED.val}/>
            </Tabs>
        </div>
    )
}
export default StudentTrailTabs;
